import { render } from "./Form.vue?vue&type=template&id=d586ff7e&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d586ff7e"

export default script